import imageCompression from "browser-image-compression";

const compressImage = async (imageData) => {
  let file;
  if (typeof imageData === 'string' && imageData.startsWith('data:image')) {
    const byteString = atob(imageData.split(',')[1]);
    const mimeString = imageData.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let j = 0; j < byteString.length; j++) {
      ia[j] = byteString.charCodeAt(j);
    }
    const blob = new Blob([ab], { type: mimeString });
    file = new File([blob], 'compressed_image.png', { type: mimeString });
  } else if (imageData instanceof File) {
    file = imageData;
  } else {
    throw new Error('Invalid image data');
  }

  if (file.size < 800 * 1024) {
    return file;
  }

  const options = {
    maxSizeMB: 0.8,
    maxWidthOrHeight: 750,
    useWebWorker: true,
  };

  try {
    const compressedFile = await imageCompression(file, options);
    console.warn(`Image after compression: ${(compressedFile.size / 1024).toFixed(2)}KB`);

    return new File([compressedFile], file.name, {
      type: file.type,
      lastModified: file.lastModified,
    });
  } catch (error) {
    console.error('Error compressing image:', error);
    return file; // Return original file if compression fails
  }
};

export default compressImage;